import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import DrawerCustom from '../../components/DrawerCustom'
import { Grid, ListItem, InputBase, List, ListItemText } from '@material-ui/core';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker'
import { GiftIcon, LeftIcon } from '../../components/icons';
import Container from '../../components/Container';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import Divider from '../../components/Divider';
import InfiniteScroll from 'react-infinite-scroll-component';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
const containerStyle = {
    width: '100%',
    height: '100%'
};
const styles = theme => ({
    map: {
        width: '100%',
        height: '100%'
    },
    footer: {
        height: 360,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        backgroundColor: theme.palette.background.secondary,
        borderTopLeftRadius: theme.spacing(4),
        borderTopRightRadius: theme.spacing(4),
        padding: theme.spacing(4)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        left: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    search: {
        marginLeft: theme.spacing(4),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        padding: theme.spacing(2, 8, 2, 4),
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.secondary,
        position: 'absolute',
        top: theme.spacing(3)
    },
    search_list: {
        backgroundColor: theme.palette.background.secondary,
        width: '90%',
        position: 'absolute',
        top: theme.spacing(10),
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
        zIndex: 999
    },
    input: {
        marginLeft: theme.spacing(2),
        //flex: 1,
        width: '200%',
    },
    item:{
        height: 56
    },
    item_image: {
        width: 48,
        height: 48,
        borderRadius: 48
    },
    item_icon: {
        width: 48,
        height: 48,
        borderRadius: 48,
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        justifyContent: 'center',
        alignItems: 'center'
    }
})
function OrderStoresView(props){
    const [markerSelected, onSelectMaker] = useState(null);
    const [search_value, setSearchValue] = useState(null);
    const [storeByName, setStoreByName] = useState(null);
    const [showList, onShowList] = useState(false);
    const [centerRegion, setCenterRegion] = useState(null);

    const onHandleChange = (value) =>{
        setSearchValue(value);
        filterByName(value);
    }
    const filterByName = (name) =>{
        var stores = props.stores;

        if (stores && stores.length > 0) {
            if (!name) {
                setStoreByName([]);
                onShowList(false)
            } else {
                var storeByName = stores.filter(store => {
                    return store.name && store.name.includes(name);
                })
                if (storeByName.length == 0) {
                    setStoreByName([]);
                    onShowList(false)
                } else {
                    setStoreByName(storeByName);
                    onShowList(true)
                }
            }
        }
    }
    const onSelect = (item, isHidePopup) =>{
        setSearchValue(item.name);
        onShowList(false);
        setStoreByName([]);
        var location = item.address;
        // console.log('onSelect item===',item)
        if (location && location.lat && location.lon) {
            var region = {
                lat: location.lat,
                lon: location.lon,
            }
            setCenterRegion(region);
        }
        onSelectMaker(item.id);
    }

    const { open, onClose, stores, showLoading, classes, storeSelected } = props;
    console.log("OrderStoresView stores:", stores);
    return (
        <Container showLoading={showLoading}>
            <DrawerCustom
                open={open}
                onClose={onClose}
                fullScreen>
                <Grid xs={12} item className={classes.map} container>
                    <GoogleMapComponent
                        center={centerRegion}>
                        {stores ? stores.map((marker, index) => {
                            var location = marker.address;
                            if (location && location.lat && location.lon) {
                                return (<GoogleMapMarker key={index}
                                    info={{ title: marker.name, description: location.address_line_1, id: marker.id }}
                                    lat={location.lat}
                                    lng={location.lon}
                                    onClick={onSelectMaker}
                                    markerSelected={markerSelected}
                                    onSelect={() => props.onSelectMerchant(marker)} />)
                            }
                        }) : null}
                    </GoogleMapComponent>
                    <Grid xs={9} sm={10} item className={classes.search} container justify='center' alignContent='center'>
                        <InputBase
                            className={classes.input}
                            placeholder={t('search_for')}
                            inputProps={{ 'aria-label': 'search google maps' }}
                            onChange={(event) => onHandleChange(event.target.value)}
                            value={search_value}
                        />
                        {showList && storeByName.length > 0 ? <Grid xs={12} item><List component="nav" aria-label="main mailbox folders" className={classes.search_list}>
                            {storeByName.map((item, index) => (
                                <ListItem button onClick={() => onSelect(item)}>
                                    <ListItemText primary={item.name} />
                                </ListItem>))}

                        </List></Grid> : null}
                    </Grid>
                </Grid>

                <Grid item className={classes.footer}>
                    <CustomTypo variant='subtitle2'>{t('locations')}</CustomTypo>
                    <Divider fullWidth />
                    <InfiniteScroll
                        dataLength={stores.length} //This is important field to render the next data
                        height={300}
                    >
                        <Grid xs={12} item container>
                            {stores.map((item, index) => (
                                <MerchantItem storeSelected={storeSelected} item={item} index={index} key={index} onSelectMerchant={props.onSelectMerchant} classes={classes} />
                            ))}</Grid>
                    </InfiniteScroll>
                </Grid>
            </DrawerCustom>
        </Container>
    );
}
function MerchantItem(props) {
    var item = props.item;
    var storeSelected = props.storeSelected;
    var distance = item.location && item.location.distance ? item.location.distance.toFixed(2) : null;
    var address = item&&item.address ? item.address.address_line_1
        + (item.address.town_city ? ', ' + item.address.town_city : '')
        + (item.address.state_province_county ? ', ' + item.address.state_province_county : '')
        + (item.address.postal_code ? ', ' + item.address.postal_code : '')
        : ''
    if (!address) {
        address = item.location&&item.location.address?item.location.address: ' '
    }
    var covertToKM = 0;
    if (distance)
        covertToKM = distance * 1.6;
    if (covertToKM)
        covertToKM = covertToKM.toFixed(2);
    return (
        <Grid xs={12} item>
            <ListItem onClick={() => props.onSelectMerchant(item)} style={{ cursor: 'pointer' }}>
                <Grid item xs ={2} container justify='center'>
                        <MerchantItemImage image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_map_merchant)} classes={props.classes}/>
                    </Grid>
                <Grid item xs={10}>
                    <CustomTypo variant='subtitle2'>{item.name}</CustomTypo>
                    <CustomTypo variant='body1'>{address}</CustomTypo>
                    {distance &&
                        <Grid item style={{ flexDirection: 'row', marginTop: 8, alignItems: "center" }}>
                            {/* <DirectionWalkIcon /> */}
                            <CustomTypo>{covertToKM} km ({distance} ml)</CustomTypo>
                        </Grid>
                    }
                </Grid>
            </ListItem>
            <Divider fullWidth />
        </Grid>
    )
}
function MerchantItemImage(props) {
    var image = props.image;
    var classes = props.classes
    if (image) {
        return <img src={image.url} className={classes.item_image} />
    } else {
        return <GiftIcon />
    }
}
export default withStyles(styles)(withTranslation()(OrderStoresView));